import React from 'react'

import { useModal } from '../../hooks/modal'
import BuildingExpenseUpdate from './BuildingExpenseUpdate'
import { maxLength } from '../../utils/string'
import { HOUSE_EXPENSE_DETAIL } from '../../urls'
import Button from '../../components/common/Button'
import { useDeleteRequest } from '../../hooks/request'
import { getDateTime } from '../../utils/date'
import { getPayment, getPaymentTypeOptions } from '../../utils/types'

export default function BuildingExpenseItem({ item, index, expense }) {
    const productRemove = useDeleteRequest({ url: HOUSE_EXPENSE_DETAIL.replace('{id}', item.id) })

    async function onDelete() {
        if (global.confirm('Вы действительно хотите удалить?')) {
            await productRemove.request()
            expense.request()
        }
    }

    const [showUpdateModal, hideUpdateModal] = useModal(
        <BuildingExpenseUpdate
            clients={item}
            item={item}
            onCancel={() => {
                expense.request()
                hideUpdateModal()
            }}
        />,
    )

    function format(value) {
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            useGrouping: true,
        })
            .format(value)
            .replace(/,/g, ' ')
    }

    console.log(item)
    return (
        <tr className=" is-size-6" key={item.id}>
            <td className="is-size-6">{index + 1}</td>
            <td className="is-size-6">{item?.selectCategory?.name}</td>
            <td className="is-size-6">{item?.selectAssigned?.username}</td>
            {/* <td className="is-size-6">{item?.selectAssigned.username}</td> */}
            <td className="is-size-6">{getPayment(item?.status)}</td>
            <td className="is-size-6" style={{ color: item?.status === 'income' ? 'green' : 'red' }}>
                {format(item?.amount)} Сум
            </td>
            <td className="is-size-6">{getDateTime(item?.createdAt)}</td>
            <td className="is-size-6">{getPaymentTypeOptions(item?.paymentType)}</td>
            <td className="is-size-6">{maxLength(item?.comment, 24)}</td>
            <td>
                <div style={{ display: 'flex' }} className="has-text-right">
                    <Button onClick={showUpdateModal} className="mr-2 button is-success is-outlined is-small" icon="pencil-outline" />
                    <Button onClick={onDelete} className="button is-danger mr-2 is-outlined is-small" icon="trash" />
                </div>
            </td>
        </tr>
    )
}
